import axios from 'axios';

import config from '@/config';

const { iffApi } = config.ctx;

export const workLogService = {
  queryPage: (params = {}) => axios.get(`${iffApi}/work-log/page`, { params }),
  dayUsers: (logDate) => axios.get(`${iffApi}/work-log/day-users`, { params: { logDate } }),
  getDetail: (id) => axios.get(`${iffApi}/work-log/detail/${id}`),
  save: (data) => axios.post(`${iffApi}/work-log/save`, data),
  confirm: (workLogIds) => axios.post(`${iffApi}/work-log/confirm`, { workLogIds }),
  confirmAll: (data) => axios.post(`${iffApi}/work-log/confirm-all`, data),
  remove: (id) => axios.delete(`${iffApi}/work-log/${id}`),
  reconcileDeptDay: (data) => axios.post(`${iffApi}/work-log/reconcile/dept-day`, data),
  workerCandidates: () => axios.get(`${iffApi}/work-log/worker-candidates`),
  export: (data) => axios.post(`${iffApi}/work-log/export`, data, { responseType: 'blob' })
};
